import React from 'react'
import PropTypes from 'prop-types'
import HrbTranslate from '../../language/HrbTranslate';
import Skeleton from '../loaders/Skeleton';
import EmdashText from '../common/EmdashText';

const LoadingText = props => {
    const { loading, isEmpty, textKey, params } = props;
    return (
        <div>
            { loading && 
                <Skeleton />    
            }
            { !loading && isEmpty &&
                <EmdashText />
            }
            {!loading && !isEmpty &&
                <HrbTranslate text={textKey} params={params} />
            }
        </div>
    )
}


LoadingText.propTypes = {
    textKey: PropTypes.string.isRequired,
    loading: PropTypes.bool,
    isEmpty: PropTypes.bool,
    params: PropTypes.object
}

export default LoadingText